import {
    Component,
    Input,
    HostBinding
} from '@angular/core';

@Component({
    selector: 'app-nw-server-item',
    templateUrl: './server-item.component.pug',
    styleUrls: ['./server-item.component.less'],
    exportAs: 'serverItem'
})
export class ServerItemComponent {
    @HostBinding('class.--ui') _ui = true;

    @Input() server: IServer;

    constructor(
    ) {
    }
}
